import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { findEmail, toggleFormUsers } from '../../../../../../../redux/actions/users'
import { resetFormValidator } from '../../../../../../../redux/actions/validator'
import { IRootState } from '../../../../../../../redux/types'
import { IUser } from '../../../../models/user'

export function useCreateState(roleId: number, setCurrentTab: any) {
  const dispatch = useDispatch()

  const { user: authUser } = useSelector((state: IRootState) => state.auth)
  const { userSelected } = useSelector((state: IRootState) => state.user)
  const { countries, provinces, towns, postalcodes } = useSelector((state: IRootState) => state.country)
  const { userBrands } = useSelector((state: IRootState) => state.brand)

  const [user, setUser] = useState<IUser>({
    parent: authUser,
    id: 0,
    name: '',
    phone: '',
    email: '',
    role_id: roleId,
    filterRoleId: roleId,
    countries: [],
    languages: [],
    brands: [],
    menus: [],
    address: '',
    country: [],
    province: [],
    town: [],
    postalcode: [],
    code: '',
    client_type: null,
    can_verify: 0,
    centerName: null,
    centerAddress: null,
    centerCountry: null,
    centerProvince: null,
    centerTown: null,
    centerPostalcode: null
  })

  // biome-ignore lint/complexity/noExcessiveCognitiveComplexity: <explanation>
  useEffect(() => {
    if (userSelected !== null && userSelected.id !== user.id) {
      const objTown = towns.find((town: any) => town.id === userSelected.person.town_id)
      const objProvince = provinces.find((province: any) => province.id === objTown.province_id)
      setUser({
        parent: authUser,
        id: userSelected.id,
        role_id: userSelected.role_id,
        filterRoleId: roleId,
        name: userSelected.name,
        phone: userSelected.phone,
        email: userSelected.email,
        countries: userSelected.countries,
        languages: userSelected.languages,
        brands: userSelected.brands,
        menus: userSelected.menus,
        address: userSelected.person.address,
        country: countries.find((country: any) => country.id === objProvince.country_id),
        province: objProvince,
        town: objTown,
        postalcode: postalcodes.find((postalcode: any) => postalcode.id === userSelected.person.postalcode_id),
        code: userSelected.commercial_code,
        client_type: userSelected.person.client_type,
        can_verify: userSelected.can_verify,
        centerName: userSelected.center != null ? userSelected.center.name : null,
        centerAddress: userSelected.center != null ? userSelected.center.address : null,
        centerCountry: userSelected.center != null ? userSelected.center.country_id : null,
        centerProvince: userSelected.center != null ? userSelected.center.province_id : null,
        centerTown: userSelected.center != null ? userSelected.center.town_id : null,
        centerPostalcode: userSelected.center != null ? userSelected.center.postalcode_id : null
      })
    }
  }, [userSelected])

  const handleModalCreate = () => {
    setUser({
      parent: authUser,
      id: 0,
      name: '',
      phone: '',
      email: '',
      role_id: roleId,
      filterRoleId: roleId,
      countries: [],
      languages: [],
      brands: [],
      menus: authUser.menus.map((menu: any) => menu.id),
      address: '',
      country: [],
      province: [],
      town: [],
      postalcode: [],
      code: '',
      client_type: null,
      can_verify: 0,
      centerName: null,
      centerAddress: null,
      centerCountry: null,
      centerProvince: null,
      centerTown: null,
      centerPostalcode: null
    })

    dispatch(toggleFormUsers())
  }

  useEffect(() => {
    if (user.email.length < 10) return

    const timeoutId = setTimeout(() => {
      dispatch(findEmail({ email: user.email, id: user.id }))
    }, 500)

    return () => clearTimeout(timeoutId)
  }, [user.email])

  const handleInputChange = (inputName: string, value: any) => {
    if (inputName === 'country') {
      setUser({ ...user, country: value, province: [], town: [], postalcode: [] })
      return
    }

    if (inputName === 'province') {
      setUser({ ...user, province: value, town: [], postalcode: [] })
      return
    }

    setUser({ ...user, [inputName]: value })

    if (inputName === 'role_id') {
      if (roleId === 6) setCurrentTab(2)
      else setCurrentTab(0)
    }
  }

  const handleCloseModalUser = () => {
    dispatch(resetFormValidator())
    dispatch(toggleFormUsers())
  }

  const handleToggleMenusClick = (value: number) => {
    const currentIndex = user.menus.indexOf(value)
    const newChecked = [...user.menus]

    if (currentIndex === -1) {
      newChecked.push(value)
    } else {
      newChecked.splice(currentIndex, 1)
    }

    setUser({ ...user, menus: newChecked })
  }

  return { user, setUser, handleInputChange, handleModalCreate, handleCloseModalUser, handleToggleMenusClick }
}
